import { render, staticRenderFns } from "./LedgerAccountsWindow.vue?vue&type=template&id=28aad615&"
import script from "./LedgerAccountsWindow.vue?vue&type=script&lang=js&"
export * from "./LedgerAccountsWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports